import { module } from './store'
import { StorefrontModule } from '@vue-storefront/core/lib/modules'

export const KEY = 'trustpilot'

export const Trustpilot: StorefrontModule = function ({ store }) {
  store.registerModule(KEY, module)
}
